import client from '@/api/client';
import { gql } from '@apollo/client';

const getAvailableSlots = (market: string) => client
  .query({
    query: gql`
      query(
        $market: BookingMarket
        $timeZone: String
      ) {
        getAvailableSlots(
          market: $market
          timeZone: $timeZone
        ) {
          date
          slots {
            time
          }
        }
      }
    `,
    variables: {
      timeZone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? 'GMT',
      market,
    },
  });

const makeBooking = (data: {
  market: string;
  time: string;
  email: string;
  name: string;
}) => client
  .mutate({
    mutation: gql`
      mutation(
        $market: BookingMarket
        $timeZone: String
        $time: String
        $email: String
        $name: String
      ) {
        makeBooking(
          market: $market
          timeZone: $timeZone
          time: $time
          email: $email
          name: $name
        ) {
          status
        }
      }
    `,
    variables: {
      timeZone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? 'GMT',
      ...data,
    },
  });

export default {
  getAvailableSlots,
  makeBooking,
};
